import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IAggregateReportQueryParams, IAggregateReportResponse } from '../types';

export const getAggregateReportDataQueryKey = 'getAggregateReportData';

const getAggregateReportData = async ({ orgId, proFormaIds, actualsProFormaIds }: IAggregateReportQueryParams): Promise<IAggregateReportResponse> => {
    const params: Record<string, number[]> = {
        pro_forma_ids: proFormaIds,
    };
    
    if (actualsProFormaIds && actualsProFormaIds.length > 0) {
        params.actuals_pro_forma_ids = actualsProFormaIds;
    }
    
    const response = await axiosInstance.get(`${API_ENDPOINTS.ORG_REPORTS(orgId)}/aggregate_report`, {
        params,
        paramsSerializer: params => Object.entries(params)
            .map(([key, value]) => (Array.isArray(value)
                ? value.map(v => `${key}=${encodeURIComponent(v)}`).join('&')
                : `${key}=${encodeURIComponent(value)}`))
            .join('&'),
    });
    return response.data;
};

export const useGetAggregateReportData = ({ orgId, proFormaIds, actualsProFormaIds }: IAggregateReportQueryParams) => useQuery({
    queryKey: ['getAggregateReportData', orgId, proFormaIds, actualsProFormaIds],
    queryFn: () => getAggregateReportData({ orgId, proFormaIds, actualsProFormaIds }),
    staleTime: 5000,
    refetchOnMount: true,
});

export default useGetAggregateReportData;
